<template>
  <div>
    <button @click="action">{{ name }}</button>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: function () {
        return ''
      }
    },
    action: {
      type: Function,
      default: function () {
        return {}
      }
    }
  }
}
</script>
